import { RootState } from '@checkout/state';
import * as cx from 'classnames';
import * as React from 'react';
import { Fragment } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import messages from './../../../i18n/base-en';
import * as Styles from './Minicart.scss';

const itemQuantitySelector = (state: RootState) =>
state.checkout.selection.items && state.checkout.selection.items.reduce((sum, product) => sum + product.quantity, 0);

interface IOwnProps {
  showLabel?: boolean;
  cartLabel?: string;
}

interface IConnectedProps {
  quantity: number;
  checkoutUrl: string;
}

interface IConnectetDispatchProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

class Minicart extends React.Component<Props, {}> {

  static defaultProps: IConnectedProps = {
    quantity: 0,
    checkoutUrl: '',
  };

  render() {
    const { intl, quantity, checkoutUrl, cartLabel, showLabel = true } = this.props;
    const { formatMessage } = intl;

    const minicartClassNames = cx({
      [Styles.minicart]: true,
      [`quantity--${quantity}`]: true,
    });

    const onlyQuantityClassNames = cx({
      [Styles.withLabel]: true,
      [`quantity--${quantity}`]: true,
    });

    const label = cartLabel ? cartLabel : formatMessage(messages.minicart_label);

    return (
      <Fragment>
        {showLabel && (
          <div className={minicartClassNames}>
            <a href={checkoutUrl}>
              <span className={Styles.label}>{label}</span>
              <span className={Styles.quantity}>{quantity}</span>
            </a>
          </div>
        )}
        {!showLabel && <span className={onlyQuantityClassNames}>{quantity}</span>}
      </Fragment>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  quantity: itemQuantitySelector(state),
  checkoutUrl: state.checkout.pathnames.checkout
});

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    mapStateToProps,
    {},
  ),
)(Minicart);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/Minicart/Minicart.tsx